import {Component} from '@angular/core';
import {IonicPage, ModalController} from 'ionic-angular';
import {SiteFormComponent} from "../../components/site-form/site-form";
import {EntityType, SiteResult} from "../../models/data.model";
import {DataProvider} from "../../providers/data/data";

@IonicPage()
@Component({
  selector: 'page-list-site',
  templateUrl: 'list-site.html',
})
export class ListSitePage {

  entityType: EntityType = EntityType.Site;

  constructor(public modalCtrl: ModalController,
              public data: DataProvider) {
    this.data.setSearchFilter(this.data.getSearchFilter());
  }


  protected getEntityTypes(): EntityType[] {
    return Object.keys(EntityType).map(c => EntityType[c]);
  }


  protected presentForm() {
    this.modalCtrl.create(SiteFormComponent).present().catch();
  }

  protected selectEnityType(entityType: EntityType) : void {
    this.entityType = entityType;
  }

  private isEntitySelected(entityType: EntityType): boolean {
    return this.entityType == entityType;
  }

  protected getEntityCountResult(entityType: EntityType): number {
    return this.data.getCountSearchResult(entityType);
  }

  protected getSearchResult(): SiteResult[] {
    return this.data.getSearchResult();
  }

  protected isSiteSelected(): boolean { return this.isEntitySelected(EntityType.Site); }

  protected isSectorSelected(): boolean { return this.isEntitySelected(EntityType.Sector); }

  protected isRouteSelected(): boolean { return this.isEntitySelected(EntityType.Route); }

}



// WEBPACK FOOTER //
// ./src/pages/list-site/list-site.ts